import z from "zod/v4";
import type { EvaluatorEvaluationMessage } from "../engines/evaluator-engine";
import { MoveUtil } from "../utils/move-util";
import { EngineModel } from "./engine-model";
import { MoveScoreSchema } from "./move-model";

export const MultiPvLineSchema = z.object({
    rank: z.number().int(),
    moves: z.string().array(),
    rootScore: MoveScoreSchema,
});

export type MultiPvLine = z.infer<typeof MultiPvLineSchema>;

export const MultiPvLine = {
    from: (evaluation: EvaluatorEvaluationMessage): MultiPvLine => {
        const rootScore = evaluation.score;
        const moves = MoveUtil.splitPvToMoves(evaluation.pv).map((uci) => uci);

        return {
            rank: evaluation.multiPv ?? 1,
            rootScore,
            moves,
        };
    },
};

export const MultiPvLineSummarySchema = z.object({
    depth: z.number(),
    engineModel: z.enum(EngineModel),
    lines: z.array(MultiPvLineSchema),
});
export type MultiPvLineSummary = z.infer<typeof MultiPvLineSummarySchema>;
export const MultiPvLineSummary = {
    from: (props: MultiPvLineSummary) => props,
};
